/**
 * @file Molecule: SoundControlButton
 * @description A button that toggles sound settings panel with volume icon.
 */

import type React from 'react';
import { useState } from 'react';
import { GearIcon } from '../atoms/Icon';
import SoundControls from './SoundControls';

interface SoundControlButtonProps {
  onClick?: () => void;
}

const SoundControlButton: React.FC<SoundControlButtonProps> = ({ onClick }) => {
  const [showSoundControls, setShowSoundControls] = useState(false);

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      setShowSoundControls(!showSoundControls);
    }
  };

  return (
    <>
      <div className="flex justify-end pt-[12px] pr-[12px] pl-[12px] z-10">
        <button
          type="button"
          onClick={handleClick}
          className="w-[24px] h-[24px] flex items-center justify-center text-white hover:text-gray-300 transition-colors"
          aria-label="Sound settings"
        >
          <GearIcon className="w-[24px] h-[24px]" />
        </button>
      </div>

      {showSoundControls && (
        <div className="absolute bottom-4 right-4 flex flex-col items-end z-20">
          <div className="sound-controls-panel p-4 bg-gray-800 bg-opacity-90 rounded-lg border border-gray-700 w-64 relative">
            <h3 className="text-white font-lekton text-lg mb-3">
              Sound Settings
            </h3>
            <SoundControls />
            <button
              type="button"
              onClick={() => setShowSoundControls(false)}
              className="absolute top-2 right-2 text-gray-400 hover:text-white"
              aria-label="Close sound settings"
            >
              ×
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default SoundControlButton;
